"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createGameEvent = void 0;
exports.createGameEvent = `mutation CreateGameEvent($input: CreateGameEventInput!) {
  createGameEvent(input: $input) {
    id
    type
    bay
    location
    players {
      id
      name
      challengesWon
      active
      wager
      __typename
    }
    timestamp
    hole
    gameCourseId
    gameCourseLevel
    content
    rawEvent
    __typename
  }
}
`;
//# sourceMappingURL=mutations.js.map